import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const ChevronLeftIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
    return (
        <MuiIcon {...props}
                 ref={ref}
        >{'\ue5cb'}</MuiIcon>
    );
})
